import { toJalaali } from "jalaali-js";

export function isoToJalali(isoString) {
  const date = new Date(isoString);
  const { jy, jm, jd } = toJalaali(date);

  return `${jy}/${String(jm).padStart(2, "0")}/${String(jd).padStart(2, "0")}`;
}
